export default function formatPledgeAmount(cents, { withDecimals = false } = {}) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: withDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format((Number(cents) || 0) / 100);
}
